const zhCNTranslation = {
  "loading": "加载中...",
  "chatbot_title": "欢迎来到你的新聊天！",
  "chatbot_description": "询问关于你的社交媒体账号的问题",
  "new_chat": "新聊天",
  "new_chat_title": "新聊天标题",
  "search_chats": "搜索聊天...",
  "send_message_placeholder": "输入你的消息...",
  "loading_assistant": "正在加载你的助手...",
  "assistant_thinking": "Lema 正在思考...",
  "drafting_answer": "正在撰写回答...",
  "notify_when_done": "想让 Lema 在完成后通知你吗？",
  "notify_me": "通知我",
  "notification_set": "准备好后我们会通知你",
  "send_instruction": "按 Enter 发送，Shift+Enter 换行",
  "select_chat_or_new": "选择一个聊天或新建一个",
  "attach_files": "附加文件",
  "assistant": "助手",
  "you": "你",
  "sources": "来源",
  "citation": "引用",
  "items": "项",
  "error_initializing_chatbot": "初始化聊天机器人时出错：",
  "failed_fetch_history": "获取消息历史失败：",
  "error_creating_chat": "创建新聊天时出错：",
  "failed_create_new_chat": "创建新聊天失败：",
  "file_upload_error": "文件上传错误：",
  "error_uploading_file": "上传文件时出错：",
  "conversation_not_found_new_one": "未找到对话，正在创建新的对话",
  "error_creating_conversation": "创建新对话时出错：",
  "error_sending_message": "发送消息时出错：",
  "error_regenerating_message": "重新生成消息时出错：",
  "conversation_error_try_again": "抱歉，对话发生错误。请重试。",
  "new_conversation_error_try_again": "抱歉，创建新对话时发生错误。请重试。",
  "processing_request_error_try_again": "抱歉，处理你的请求时发生错误。请重试。",
  "regenerating_message_error_try_again": "抱歉，重新生成消息时发生错误。请重试。",
  "request_timed_out_try_again": "请求超时。请重试。",
  "generic_error": "错误：",
  "generic_processing_error_try_again": "抱歉，处理你的请求时发生错误。",
  "stop_generation": "停止生成",
  "stop": "停止",
  "start_conversation": "开始对话",
  "cancel": "取消",
  "save_edit": "保存",
  "download_file": "下载文件",
  "no_chats_found": "没有找到匹配你搜索的聊天。",
  "no_chats_yet": "还没有聊天。开始一个新的吧！",
  "rename_chat": "重命名聊天",
  "confirm_delete_chat": "确定要删除聊天“{{title}}”吗？",
  "search": {
    "title": "品牌搜索",
    "placeholder": "搜索品牌...",
    "search_button": "搜索",
    "loading": "正在搜索品牌...",
    "empty_state": "输入搜索词以查找品牌合作机会",
    "connect_title": "连接你的账号",
    "connect_description": "连接你的社交媒体，让 Lema 为你找到合作品牌",
    "connect_button": "前往账号设置",
    "loading_search": "正在加载搜索...",
    "visit_website": "访问网站",
    "score": "评分",
    "description": "搜索品牌推荐并监控新的匹配",
    "error_label": "错误",
    "recommended_brands": "推荐品牌",
    "brands": "品牌",
    "relevance": "相关度",
    "lead_score": "线索评分",
    "profile": "资料",
    "collapse_tooltip": "点击收起",
    "expand_tooltip": "点击展开",
    "results_range": "{{start}}-{{end}} / {{total}} 个结果",
    "zero_results": "0 个结果",
    "unexpected_response": "服务器返回了意外的响应格式",
    "auth_required": "需要身份验证。请重新登录。",
    "connect_account_before_search": "请先连接社交媒体账号再搜索。前往账号设置连接账号。",
    "search_failed": "执行搜索失败",
    "unexpected_error": "发生了意外错误",
    "recommendations_tab": "推荐",
    "history_tab": "历史记录",
    "affiliate_recommendations": "联盟推荐",
    "results": "结果",
    "no_affiliate_recommendations": "未找到联盟推荐",
    "affiliate_recommendations.brands": "品牌",
    "affiliate_recommendations.description": "描述",
    "affiliate_recommendations.recommendation_score": "评分",
    "affiliate_recommendations.commission_rate": "佣金",
    "affiliate_recommendations.audience": "受众",
    "affiliate_recommendations.apply": "申请",
    "affiliate_recommendations.commission": "佣金"
  },
  "delete_chat": "删除聊天",
  "remove_file": "移除文件",
  "uploading_files": "正在上传文件...",
  "send_message": "发送消息",
  "type_message_or_attach": "输入消息或附加文件",
  "send_instruction_short": "Enter 发送，Shift+Enter 换行",
  "like_message": "点赞消息",
  "remove_like": "取消点赞",
  "dislike_message": "点踩消息",
  "remove_dislike": "取消点踩",
  "copy_message": "复制消息",
  "reply_to_message": "回复消息",
  "edit_message": "编辑消息",
  "regenerate_response": "重新生成回复",
  "drop_files_here": "将文件拖到这里",
  "chats_title": "聊天",
  "jump_to_original": "跳转到原消息",
  "replying_to": "正在回复",
  "error_file_too_large": "超过 {{maxSize}} 限制的文件：{{files}}",
  "error_compress_first": "请先压缩文件或尝试更小的文件。",
  "agent": {
    "tools": {
      "find_brand_leads": "查找品牌线索",
      "query_database": "正在从数据库获取数据",
      "searching_web": "正在搜索网页",
      "creating_post": "正在创建帖子",
      "lead_gen_v9": "正在寻找品牌",
      "google_instagram_search": "正在搜索网页",
      "create_post": "正在创建帖子",
      "query_supabase_v2": "正在获取数据",
      "scrape_tiktok_profile": "正在获取 TikTok 资料",
      "scrape_instagram_profile": "正在获取 Instagram 资料",
      "link_captioner": "正在理解链接",
      "fetching_audience": "正在获取受众数据",
      "deep_statistics_agent": "正在分析统计数据",
      "plan": "计划",
      "tool_call": "工具调用",
      "working": "处理中"
    }
  },
  "indexing_messages": [
    "正在获取你的数据...",
    "正在理解你的资料...",
    "正在索引你的文本...",
    "正在写入记忆...",
    "正在下载你的图片...",
    "正在下载你的视频...",
    "正在压缩你的图片...",
    "正在压缩你的视频...",
    "正在为你的图片创建向量嵌入...",
    "正在为你的视频创建向量嵌入...",
    "正在写入记忆...",
    "正在清理你的数据..."
  ],
  "connect": {
    "title": "连接你的账号",
    "button": "前往账号设置",
    "chat_description": "连接你的社交媒体，解锁个性化内容洞察并与 Lema 聊天",
    "portfolio_description": "连接你的社交账号以生成你的作品集。"
  },
  "error": {
    "rate_limit_title": "已达到速率限制",
    "rate_limit_message": "请在 1 分钟后重试，或升级到付费方案以减少中断",
    "rate_limit_monthly_exceeded": "你每月的消息额度已用完。请升级你的方案以继续。",
    "rate_limit_wait_and_retry": "请求过多。请稍后再试",
    "dify_agent_title": "处理错误",
    "dify_agent_message": "Lema 遇到了错误。请重新生成或发送其他消息",
    "content_policy_title": "Lema 遇到了错误",
    "content_policy_message": "请重新生成或发送其他消息",
    "could_not_recover_response": "Lema 仍在生成你的回复。请几分钟后刷新。",
    "chat_rate_limit_exceeded": "已达到速率限制。请升级你的方案。",
    "chat_critical_error": "发生严重错误。",
    "chat_regenerate_failed": "重新生成回复失败。",
    "chat_resend_failed": "重新发送消息失败。",
    "chat_stream_error": "流错误",
    "chat_read_stream_error": "读取响应流时出错。",
    "chat_timeout": "请求超时。请重试。",
    "chat_no_response_body": "未收到响应内容",
    "chat_stop_streaming_failed": "停止流式响应失败",
    "chat_init_chatbot_failed": "初始化聊天机器人失败",
    "chat_fetch_history_failed": "获取消息历史失败",
    "chat_create_chat_failed": "创建新聊天失败",
    "chat_create_conversation_failed": "创建新对话失败",
    "chat_send_message_failed": "发送消息失败",
    "chat_conversation_error": "抱歉，对话发生错误。请重试。",
    "chat_new_conversation_error": "抱歉，创建新对话时发生错误。请重试。",
    "chat_processing_error": "抱歉，处理你的请求时发生错误。请重试。",
    "chat_generic_error": "抱歉，处理你的请求时发生错误。",
    "chat_recover_failed": "无法从服务器恢复回复。请创建新聊天并重新发送消息",
    "auth_verification_failed": "验证失败。请重试。",
    "auth_google_signin_failed": "启动 Google 登录失败。请重试。",
    "auth_google_signup_failed": "启动 Google 注册失败。请重试。",
    "auth_password_mismatch": "密码不匹配",
    "auth_session_expired": "你的会话已过期。请重新登录。",
    "auth_sign_out_failed": "退出登录失败",
    "auth_update_state_failed": "更新认证状态失败",
    "auth_refresh_session_failed": "刷新会话失败",
    "auth_init_auth_failed": "初始化认证失败",
    "file_upload_failed": "上传文件失败",
    "file_too_large": "文件大小超过最大限制",
    "file_compress_first": "请先压缩文件或尝试更小的文件。",
    "file_invalid_format": "文件格式无效",
    "file_caption_failed": "字幕生成失败",
    "file_caption_timeout": "字幕请求超时。",
    "file_caption_invalid_response": "字幕请求成功，但响应不是有效的 JSON。",
    "file_url_upload_failed": "URL 上传失败",
    "social_load_instagram_failed": "加载 Instagram 数据失败",
    "social_load_tiktok_failed": "加载 TikTok 数据失败",
    "social_load_youtube_failed": "加载 YouTube 数据失败",
    "social_disconnect_failed": "断开账号失败",
    "social_connection_failed": "连接失败",
    "social_token_exchange_failed": "令牌交换失败",
    "social_save_connection_failed": "保存连接时发生错误。",
    "social_fetch_accounts_failed": "获取账号失败",
    "social_select_account_failed": "选择账号失败",
    "social_indexing_failed": "索引失败",
    "social_indexing_timeout": "等待完成时索引超时",
    "social_fetch_timeout": "等待完成时社交数据获取超时",
    "portfolio_enter_username": "请输入用户名",
    "portfolio_user_not_found": "系统中未找到该用户名。",
    "portfolio_connect_first": "请先在此处连接账号",
    "portfolio_generation_failed": "生成作品集失败",
    "portfolio_generic_error": "生成作品集时发生错误",
    "portfolio_not_found_title": "未找到作品集",
    "search_unexpected_response": "服务器返回了意外的响应格式",
    "search_auth_required": "需要身份验证。请重新登录。",
    "search_connect_account_first": "请先连接社交媒体账号再搜索。前往账号设置连接账号。",
    "search_failed": "执行搜索失败",
    "search_unexpected_error": "发生了意外错误",
    "verification_rate_limit": "请稍后再试",
    "verification_send_failed": "发送验证邮件失败。请重试。",
    "subscription_already_active_title": "发现有效订阅",
    "subscription_already_active_message": "你已经有一个有效订阅。请在账号页面管理你的订阅。",
    "general_unexpected_error": "给你带来不便，我们深表歉意。发生了意外错误。",
    "general_network_error": "网络错误。请检查你的连接。",
    "general_timeout": "请求超时。请重试。",
    "general_unknown_error": "发生未知错误",
    "general_fetch_failed": "获取数据失败",
    "general_save_failed": "保存更改失败",
    "general_load_failed": "当前无法加载数据。"
  },
  "success": {
    "auth_sign_in_success": "登录成功",
    "auth_sign_out_success": "退出登录成功",
    "auth_verification_sent": "验证邮件已发送",
    "social_connected": "账号连接成功",
    "social_disconnected": "账号断开成功",
    "social_indexing_complete": "索引已成功完成",
    "portfolio_generated": "作品集生成成功",
    "file_uploaded": "文件上传成功",
    "chat_message_sent": "消息发送成功"
  },
  "warning": {
    "file_size_warning": "检测到大文件。上传前请考虑先压缩。",
    "file_format_warning": "此文件格式可能不受支持。",
    "social_disconnection_warning": "断开连接将移除你数据的访问权限。",
    "social_indexing_in_progress": "索引正在进行中。请不要关闭此页面。",
    "chat_long_response": "正在生成详细回复，可能需要一点时间。",
    "chat_incomplete_response_title": "流已中断",
    "chat_incomplete_response": "回复不完整。刷新以查看完整消息。"
  },
  "common": {
    "close": "关闭",
    "collapse_sidebar": "收起侧边栏",
    "close_sidebar": "关闭侧边栏",
    "scroll_to_view": "滚动查看",
    "click_days_for_details": "点击日期查看内容详情",
    "explore_idea_deeper": "更深入探索这个想法",
    "swipe_to_scroll": "滑动浏览",
    "click_arrows_to_scroll": "点击箭头滚动"
  },
  "rate_limit_exceeded": "你每月的消息额度已用完。请升级你的方案以继续。",
  "nav": {
    "pricing": "价格",
    "chat": "聊天",
    "search": "搜索",
    "portfolio": "作品集",
    "account": "账号",
    "signOut": "退出登录",
    "signIn": "登录",
    "getStarted": "免费开始",
    "overview": "概览",
    "platforms": "平台",
    "features": "功能",
    "about": "关于",
    "demo": "演示",
    "openMainMenu": "打开主菜单",
    "expandChatHistory": "展开聊天历史",
    "dataStatus": {
      "connected": "数据已连接",
      "needsUpdate": "数据需要更新",
      "loading": "数据加载中",
      "notConnected": "数据未连接",
      "checking": "正在检查数据状态...",
      "labelNotConnected": "数据未连接"
    }
  },
  "portfolio": {
    "title": "作品集生成器",
    "description": "为你的社交媒体内容创建专业作品集",
    "instagram_username_label": "用户名",
    "username_placeholder": "username",
    "error_enter_username": "请输入用户名",
    "error_user_not_found": "系统中未找到该用户名。",
    "error_connect_first": "请先在此处连接账号",
    "error_generation_failed": "生成作品集失败",
    "error_generic": "生成作品集时发生错误",
    "generating": "正在生成作品集...",
    "generate_button": "生成新作品集",
    "publicly_accessible_at": "生成的作品集将可公开访问于",
    "existing_portfolio_title": "现有作品集",
    "visit_button": "访问",
    "preview_title": "作品集预览",
    "connect_title": "连接你的账号",
    "connect_description": "连接你的社交媒体，解锁个性化作品集创建并展示你的内容",
    "connect_button": "前往账号设置"
  },
  "portfolioDisplay": {
    "loading": "正在加载作品集...",
    "not_found_title": "未找到作品集",
    "generate_new": "生成新作品集",
    "audience": "受众",
    "niche_performance": "细分领域表现",
    "metrics": {
      "followers": "粉丝",
      "engagement": "互动",
      "average_views": "平均观看量",
      "peak_views": "峰值观看量",
      "average_views_label": "平均观看量",
      "engagement_label": "互动率",
      "per_post_in_niche": "每篇帖子在该细分领域"
    },
    "contact_me": "联系我",
    "no_contact_info": "没有可用的联系信息"
  },
  "landing": {
    "placeholder_profile_link": "Instagram / TikTok 资料链接...",
    "placeholder_brands": "手工艺术品牌...",
    "action_button_evaluate": "(评估我的资料)",
    "action_button_find_brand": "(寻找品牌赞助)",
    "action_button_engagement": "(计算互动率)",
    "action_text_evaluate": "评估我的资料",
    "action_text_find_brand": "寻找品牌赞助",
    "action_text_engagement": "计算互动率",
    "action_text_create_script": "创建脚本",
    "prompt_create_content_calendar": "为我创建10天内容日历",
    "placeholder_evaluate": "输入你的 Instagram / TikTok / YouTube 链接",
    "placeholder_find_brand": "输入你想找的品牌",
    "placeholder_engagement": "输入你的 Instagram / TikTok / YouTube 链接",
    "placeholder_create_script": "输入你的 Instagram / TikTok / YouTube 链接",
    "press_enter_to_ask_ai": "按 Enter 向 Lema 提问",
    "hero_title": "Lema：创作者 AI",
    "hero_subtitle_prefix": "创作者伙伴，能够",
    "hero_subtitle_cocreate": "随时与你共同创作",
    "hero_subtitle_analytics": "解读你的数据分析",
    "hero_subtitle_available": "理解你的全部内容",
    "overview_title": "你的 AI 伙伴",
    "overview_description": "一个看过你所有内容、随时可以共同创作、并能解读你的数据而无需你自己动手的 AI。",
    "continuation_text": "继续即表示你同意我们的",
    "terms_of_service": "服务条款",
    "privacy_policy": "隐私政策",
    "features_title": "Lema 能为你做什么",
    "features_subtitle": "专为创作者打造的 AI 伙伴",
    "feature_cocreate_title": "一起共创",
    "feature_cocreate_description": "与真正了解你作品的 AI 一起头脑风暴、写脚本并完善你的创意愿景。",
    "animation_cocreate_user": "我的下一个美食视频该拍什么？",
    "animation_cocreate_lema_before": "根据你表现最好的短视频，",
    "animation_cocreate_lema_highlight": "带有清晰步骤说明的 DIY 食谱",
    "animation_cocreate_lema_after": "会多获得 90% 的点赞。",
    "animation_cocreate_tip1": "试试自制凤梨酥教程",
    "animation_cocreate_tip2": "加上成本拆解的开头钩子",
    "feature_understand_data_title": "理解你的数据",
    "feature_understand_data_description": "弄清楚什么有效、什么无效以及原因，让你做出更聪明的内容决策。",
    "feature_always_there_title": "一路陪伴你",
    "feature_always_there_description": "需要第二意见？剪辑卡住了？Lema 会在你需要时一直在线。",
    "platforms_title": "我们服务的平台",
    "platforms_subtitle": "Instagram、TikTok 和 YouTube",
    "pricing_title": "价格",
    "pricing_subtitle": "选择最适合你的方案。",
    "billing_monthly": "月付",
    "billing_yearly": "年付",
    "pricing_plans": {
      "free": {
        "title": "免费版",
        "button_text": "开始使用",
        "price_description": "每月"
      },
      "pro": {
        "title": "Pro",
        "button_text": "选择方案",
        "price_description": "每月",
        "monthly_price": "$20 / ¥144",
        "yearly_price": "$16 / ¥115",
        "yearly_helper": "（按月计费）每年 {{usd}} / {{cny}}"
      },
      "pro_plus": {
        "title": "Pro+",
        "button_text": "选择方案",
        "price_description": "每月",
        "monthly_price": "$60 / ¥432",
        "yearly_price": "$48 / ¥346",
        "yearly_helper": "（按月计费）每年 {{usd}} / {{cny}}"
      }
    },
    "pricing_features": {
      "credits_free": "30 个可用于以下用途的额度",
      "credits_pro": "100 个可用于以下用途的额度",
      "credits_pro_plus": "500 个可用于以下用途的额度",
      "brainstorm_growth": "头脑风暴如何增长你的账号",
      "analyze_performance": "分析内容为何表现好 / 不好",
      "generate_content_ideas": "生成内容创意",
      "search_brands_collab": "想问什么建议都可以！"
    },
    "pricing_recommended": "推荐",
    "pricing_redirecting": "正在跳转...",
    "about_title": "关于我们",
    "about_team_title": "我们的团队",
    "about_team_body": "我们由两位创始人组成（前 Meta 内容与机器学习团队，Oxford + Huawei Research）。",
    "about_name_origin_title": "名字的由来",
    "about_name_origin_body": "为什么叫 Lema？在数学中，“lemma”是帮助证明更大定理的小定理。我们相信人们应该能靠自己热爱的事情谋生，而 Lema 就是我们用来证明这一点的工具。",
    "about_impact_title": "影响力",
    "stat_founded": "成立时间",
    "stat_creators_served": "服务创作者数",
    "stat_brand_deals_closed": "完成的品牌合作数",
    "about_support_body": "我们热爱内容创作，也希望支持你的创作者之路",
    "about_talk_button": "直接与我们聊聊",
    "animation": {
      "views_up": "播放上升，钩子很强",
      "shares_dip": "分享下降，角度更具争议",
      "saves_spike": "收藏激增，实用性很强",
      "reach_drops": "触达下降，开头偏弱",
      "comments_up": "评论上升，时刻更有共鸣",
      "likes_dip": "点赞下降，信息不够清晰"
    },
    "vs_title": "为什么选 Lema，而不是 ChatGPT？",
    "vs_title_prefix": "为什么选 Lema，而不是",
    "try_it_now": "立即尝试",
    "vs_subtitle": "大多数 AI 不是为创作者而生。Lema 是。",
    "vs_creators_title": "基于头部创作者训练",
    "vs_creators_description": "Lema 研究高互动创作者的做法，把真实创作者数据转化为模式，而不是泛化的网页内容。",
    "vs_video_title": "真的会看视频",
    "vs_video_description": "粘贴一个链接，Lema 会真正观看它。其他 AI 工具通常做不到，只会编造内容。",
    "vs_personal_title": "了解你的账号",
    "vs_personal_description": "Lema 会根据你真正发布过的内容给出建议，不会只说“多发一点”或“跟随趋势”这种空泛建议。",
    "vs_animation_patterns_header": "头部创作者信号",
    "vs_patterns_industry_cooking": "头部美食创作者",
    "vs_pattern_cooking_1": "科学 / 实验室演示",
    "vs_pattern_cooking_2": "清晰的分步教程",
    "vs_pattern_cooking_3": "食谱 + DIY 内容",
    "vs_patterns_industry_beauty": "头部美妆创作者",
    "vs_pattern_beauty_1": "前后对比变身",
    "vs_pattern_beauty_2": "一起准备（GRWM）流程",
    "vs_pattern_beauty_3": "平价替代品评测",
    "vs_patterns_industry_travel": "头部旅行创作者",
    "vs_pattern_travel_1": "隐藏目的地揭秘",
    "vs_pattern_travel_2": "低预算旅行技巧",
    "vs_pattern_travel_3": "一天生活 vlog",
    "vs_patterns_industry_fitness": "头部健身创作者",
    "vs_pattern_fitness_1": "动作纠正拆解",
    "vs_pattern_fitness_2": "30 天挑战系列",
    "vs_pattern_fitness_3": "备餐 + 训练组合",
    "vs_patterns_industry_lifestyle": "头部生活方式创作者",
    "vs_pattern_lifestyle_1": "晨间日常 POV",
    "vs_pattern_lifestyle_2": "房间改造展示",
    "vs_pattern_lifestyle_3": "效率流程讲解",
    "vs_animation_patterns_footer": "Lema 从这些模式中学习",
    "vs_animation_video_watching": "观看中...",
    "vs_animation_video_done": "✓ 已分析",
    "vs_animation_video_tag_1": "教程形式",
    "vs_animation_video_tag_2": "0:03 的强钩子",
    "vs_animation_video_tag_3": "清晰的行动号召",
    "vs_animation_personal_label": "为你准备",
    "vs_animation_personal_followers": "{{count}} 粉丝",
    "vs_animation_personal_insight_label": "洞察",
    "vs_animation_personal_insight_text": "你 1 分钟以内且语音占比超过 70% 的视频，留存率和平均观看时长更高。",
    "vs_animation_personal_insight_text_2": "分步教程带来的收藏量比你的生活方式内容高 3 倍。",
    "vs_animation_personal_insight_text_3": "带屏幕字幕的内容，从首次观看者那里获得的重播次数高出 45%。",
    "vs_animation_personal_scanning": "分析中...",
    "vs_animation_personal_analyzed": "已分析"
  },
  "authVerifyEmail": {
    "titleDefault": "检查你的邮箱",
    "titleSent": "邮件已发送！",
    "descriptionDefault": "我们已向 {{email}} 发送确认邮件",
    "descriptionSent": "我们已再次向 {{email}} 发送确认邮件",
    "noEmailTitle": "需要验证",
    "noEmailDescription": "请先注册以接收验证邮件。",
    "backToSignUp": "返回注册",
    "bodyIntro": "请点击邮件中的链接验证你的账号并完成注册。",
    "bodyExpiry": "该链接将在 24 小时后失效。",
    "notReceived": "没看到邮件？请检查垃圾邮件文件夹或",
    "resendCta": "重新发送验证邮件",
    "sending": "发送中...",
    "rateLimitError": "请稍后再试",
    "genericError": "发送验证邮件失败。请重试。",
    "rateLimitCountdown": "请等待 {{seconds}} 秒后再试",
    "continueToSignIn": "继续登录"
  },
  "account": {
    "title": "账号设置",
    "no_accounts_found": "未找到 Instagram 账号",
    "no_threads_accounts_found": "未找到 Threads 账号",
    "connect_methods_message": "使用以下方式连接你的账号：",
    "connecting": "连接中...",
    "connect_with_facebook": "通过 Facebook 登录连接 Instagram",
    "connect_with_instagram": "连接 Instagram",
    "connect_with_threads": "连接 Threads",
    "no_tiktok_accounts_found": "未找到 TikTok 账号",
    "connect_with_tiktok": "连接 TikTok",
    "connect_with_tiktok_business": "连接你的 TikTok Business 账号",
    "no_youtube_accounts_found": "未找到 YouTube 账号",
    "connect_with_youtube": "连接 YouTube",
    "go_back_to_account": "← 返回账号页面",
    "select_account_title": "选择你的 Instagram 账号",
    "select_account_description": "选择你想与 Lema 一起使用的 Instagram 专业账号",
    "no_professional_accounts_found": "未找到 Instagram 专业账号",
    "no_professional_accounts_description": "未发现与你的 Facebook 账号关联的 Instagram 专业账号。",
    "retrying": "重试中...",
    "try_again": "重试",
    "processing": "处理中...",
    "continue": "继续",
    "instagram_professional_accounts": "Instagram 专业账号",
    "report_issues": "如有问题和 / 或反馈，请联系",
    "connect_social_accounts": "连接你的社交媒体账号",
    "usage": {
      "title": "使用情况摘要",
      "usage_since": "自 {{date}} 起的使用情况",
      "loading": "正在加载使用数据…",
      "plan_label": "方案",
      "unused": "未使用",
      "of_limit_used": "已使用 /{{limit}}",
      "available": "可用 {{limit}}",
      "left": "剩余 {{count}}",
      "unlimited": "无限制",
      "error_unable_to_load": "当前无法加载使用数据。",
      "retry": "重试",
      "credits_title": "使用额度",
      "credits_description": "{{tier}} 方案的每月额度。",
      "need_more": {
        "title": "需要更多？",
        "description": "Pro 每月提供 100 个额度，Pro+ 每月提供 300 个额度。",
        "upgrade_pro": "升级到 Pro",
        "upgrade_pro_plus": "升级到 Pro+",
        "cancel_subscription": "取消订阅",
        "contact_for_credits": "联系我们获取更多额度"
      },
      "cancel_dialog": {
        "title": "取消订阅",
        "message": "你的账号将降级为 Free，且不会退款。是否继续？",
        "confirm": "确认",
        "cancel": "取消",
        "canceling": "取消中...",
        "success": "订阅已成功取消",
        "error": "取消订阅失败"
      },
      "upgrade_dialog": {
        "title": "确认升级订阅",
        "message": "从 {{currentPlan}}（每月 ${{currentPrice}}）升级到 {{newPlan}}（每月 ${{newPrice}}），每月可获得 {{newCredits}} 个额度。今天将按比例收费。",
        "confirm": "确认升级",
        "cancel": "取消",
        "upgrading": "升级中..."
      },
      "upgrade_success": "订阅升级成功！",
      "plan_names": {
        "free": "免费版",
        "pro": "Pro",
        "pro_plus": "Pro+"
      }
    },
    "password_panel_title": "修改 / 设置密码",
    "password_panel_description": "用于邮箱和密码登录",
    "password_change_title": "修改密码",
    "password_set_title": "设置密码",
    "password_set_description": "以启用邮箱和密码登录",
    "update_password_button": "更新密码",
    "set_password_button": "设置密码",
    "password_updating": "更新中...",
    "password_change_cta": "修改密码",
    "password_set_cta": "设置密码"
  },
  "auth": {
    "signup_title": "免费开始",
    "signup_subtitle": "你不需要连接任何社交媒体账号 😉",
    "field_required": "请填写此字段。",
    "email_label": "邮箱",
    "password_label": "密码",
    "repeat_password_label": "重复密码",
    "email_placeholder": "you@example.com",
    "password_placeholder": "********",
    "repeat_password_placeholder": "********",
    "creating_account": "正在创建账号...",
    "continue_with_email": "通过邮箱继续",
    "continue_with_google": "通过 Google 继续",
    "or": "或",
    "already_have_account": "已经有账号了？",
    "sign_in": "登录",
    "error_password_mismatch": "密码不匹配",
    "error_verification_failed": "验证失败。请重试。",
    "error_google_signup_failed": "启动 Google 注册失败。请重试。",
    "connecting": "连接中...",
    "signin_title": "登录",
    "forgot_password": "忘记密码？",
    "dont_have_account": "还没有账号？",
    "sign_up": "注册",
    "signing_in": "登录中...",
    "error_google_signin_failed": "启动 Google 登录失败。请重试。",
    "oauth_blocked_title": "Google 登录被阻止",
    "oauth_blocked_description": "出于安全原因，Google 不允许从应用内浏览器登录。请复制下方链接，并在 Safari 或 Chrome 中打开。",
    "oauth_blocked_step1": "点击下方「复制链接」",
    "oauth_blocked_step2": "打开 Safari 或 Chrome",
    "oauth_blocked_step3": "粘贴链接并登录",
    "oauth_blocked_email_fallback": "或改用邮箱登录",
    "copy_link": "复制链接",
    "in_app_browser_notice_prefix": "如果您想使用 Google 登录，请重新打开",
    "in_app_browser_notice_suffix": "在首选浏览器（Chrome / Firefox / Safari）中，而不是在 {{browserName}} 内",
    "copied": "已复制！"
  },
  "connectPopup": {
    "title": "连接一个账号",
    "subtitle": "避免因缺少数据而出错，并获得更好的分析结果",
    "providers": {
      "instagram": {
        "name": "Instagram",
        "description": "连接你的 Instagram 账号。"
      },
      "youtube": {
        "name": "YouTube",
        "description": "连接你的 YouTube 账号。"
      },
      "tiktok": {
        "name": "TikTok",
        "description": "连接你的 TikTok 账号。"
      }
    },
    "active_accounts": "{{count}} 个已激活",
    "connect_button": "安全连接"
  },
  "chat": {
    "title": "询问关于你的社交媒体账号的问题",
    "placeholder": "提出一个问题...",
    "send_instruction": "Enter 发送，Shift+Enter 换行",
    "quick_actions": {
      "open_last_chat": "打开上一次对话",
      "lead_search": "寻找赞助线索",
      "collab_of_the_week": "本周合作推荐",
      "engagement_rate": "我过去 30 天的互动率是多少？",
      "create_video": "根据我表现最好的帖子创建一个视频",
      "most_viewed_post": "为什么我观看量最高的帖子表现这么好？",
      "evaluate_profile": "评估我的创作者资料和内容策略",
      "next_video_type": "我接下来应该发什么？",
      "grow_followers": "这个月我该如何增加粉丝？",
      "find_brand_sponsorship_deals": "为我寻找品牌赞助机会",
      "find_sponsorships": "查看本周合作推荐",
      "create_portfolio": "创建你自己的创作者作品集网站",
      "tutorial": "给我一个关于你能做什么的教程",
      "create_content_plan": "创建 10 天内容计划",
      "compare_highest_lowest": "比较我过去 30 天观看量最高和最低的帖子",
      "optimize_bio": "优化我的简介"
    }
  },
  "authModal": {
    "close": "关闭"
  },
  "portfolioViews": {
    "title": "作品集浏览量",
    "last_24_hours": "最近 24 小时",
    "loading": "正在加载浏览统计...",
    "total_views": "总浏览量",
    "unique_viewers": "独立访客",
    "empty": "还没有记录浏览。分享你的作品集链接以开始追踪。"
  },
  "account_social": {
    "disconnect": "断开连接",
    "disconnect_aria": "断开账号",
    "update_ai": "用最新数据更新 Lema",
    "update_ai_aria": "正在更新 Lema",
    "instagram_direct": "直接连接",
    "instagram_via_facebook": "通过 Facebook",
    "facebook_connected": "Facebook 已连接",
    "no_instagram_professional": "但未找到 Instagram 专业账号。请确认你的 Facebook 页面已关联 Instagram 专业账号。",
    "change_instagram_account": "更换 Instagram 账号",
    "view_channel": "查看频道",
    "unlock_analytics": "✨ 更新高级分析模型",
    "unlock_analytics_locked": "🔒 解锁高级分析",
    "unlock_analytics_aria": "解锁内容预测和高级分析",
    "unlock_analytics_loading": "正在分析...",
    "unlock_analytics_modal_title": "解锁内容预测与高级分析",
    "unlock_analytics_modal_description": "获取你内容创意的预测观看量和点赞数，以及内容表现原因的详细解析（例如：露脸 +20% 观看量）",
    "unlock_analytics_modal_cta": "升级至 Pro"
  },
  "account_indexing": {
    "instagram": {
      "checking": "正在检查你的 Instagram 账号...",
      "analyzing": "正在分析你的内容策略...",
      "gathering_insights": "正在从你的帖子中收集洞察...",
      "learning_audience": "正在了解你的受众偏好...",
      "organizing": "正在整理你的社交媒体数据...",
      "finalizing": "马上完成，正在完善你的资料..."
    },
    "tiktok": {
      "checking": "正在检查你的 TikTok 账号...",
      "analyzing": "正在分析你的内容趋势...",
      "gathering_insights": "正在从你的视频中收集洞察...",
      "learning_audience": "正在了解你的受众偏好...",
      "organizing": "正在整理你的社交媒体数据...",
      "finalizing": "马上完成，正在完善你的资料..."
    },
    "youtube": {
      "checking": "正在检查你的 YouTube 频道...",
      "analyzing": "正在分析你的内容表现...",
      "gathering_insights": "正在从你的视频中收集洞察...",
      "learning_audience": "正在了解你的受众偏好...",
      "organizing": "正在整理你的频道数据...",
      "finalizing": "马上完成，正在完善你的资料..."
    }
  },
  "agent_thinking": {
    "agent": "智能体",
    "analyzing_user_question": "正在分析你的问题",
    "applying_socmed_best_practices": "应用社媒最佳实践",
    "researching_platform": "研究平台",
    "diving_to_data": "深入数据",
    "thinking": "思考中...",
    "planning": "计划中...",
    "understanding": "正在理解...",
    "processing": "处理中...",
    "working": "工作中..."
  },
  "agent_tools": {
    "get_schema_and_table": "获取数据表结构",
    "lead_gen_v9": "正在寻找品牌",
    "google_instagram_search": "正在搜索网页",
    "google_ig_tt_yt_search": "正在搜索网页",
    "create_post": "正在创建帖子",
    "query_supabase_v2": "正在获取数据",
    "query_database": "正在从数据库获取数据",
    "scrape_tiktok_profile": "正在获取 TikTok 资料",
    "scrape_instagram_profile": "正在获取 Instagram 资料",
    "scrape_youtube_profile": "正在获取 YouTube 资料",
    "link_captioner": "正在理解链接",
    "cobalt_link": "正在转换链接",
    "fetch_youtube_video_detail": "正在获取 YouTube 视频",
    "fetching_audience": "正在获取受众数据",
    "fetch_audience": "正在获取受众数据",
    "deep_statistics_agent": "正在分析统计数据",
    "searching_web": "正在搜索网页",
    "creating_post": "正在创建帖子",
    "query_caption": "正在获取创作者写作风格",
    "tool_call": "工具调用"
  }
};

export default zhCNTranslation;
